import { render, staticRenderFns } from "./DiagnosticosList.vue?vue&type=template&id=4765aba6"
import script from "./DiagnosticosList.vue?vue&type=script&lang=js"
export * from "./DiagnosticosList.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticosList.vue?vue&type=style&index=0&id=4765aba6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports